<template >
   <div style="height:100%">
    <div  v-if="ttype==0" style="height:100%;background-color: #ECEEF3">
    <!-- vertical sports menu -->
        <ul :class="clsname">
       
            <li v-for="(row,i) in $store.state.sports" :key="i">
                <router-link  :to="{name:'sport', params: {sport:row.D, opencountry: 'All' }}" style="background-color:lightgrey;margin:5px 5px 0px 5px; border-radius: 8px;line-height:22px">
                    
                        <div  :class="row.Description" ></div>
                        <div class="qsmallfontplus1 qborderlink" style="min-width:80px;text-align:center" v-html="langConv(row.Friendly)" ></div>
                   
                </router-link>
            </li>

    </ul>
    </div>
    <!-- horizontal sports menu items for small screens -->
    <div v-if="ttype==1" style="background-color: #E6E7E9; height:44px">
   
             <SsrCarousel :slides-per-page='7'
               :responsive="[
           
                { maxWidth: 1024, slidesPerPage: 7 },
                { maxWidth:  890, slidesPerPage: 6 },
                { maxWidth:  780  , slidesPerPage: 5 },
                { maxWidth:  670, slidesPerPage: 4 },
                { maxWidth:  560  , slidesPerPage: 3 },
                { maxWidth:  450, slidesPerPage: 3 },
         

            ]" 
            :show-arrows="true"
            >
            <div class="slide" v-for="(row,i) in $store.state.sports" :key="i" >
                
                <router-link :to="{name:'sport', params: {sport:row.D, opencountry: 'All' }}">
               
                    <div class="grid-x text-center" style="background-color: lightgrey; border-radius: 8px;padding:5px 5px 5px 5px;line-height:24px; margin-top:5px" >
                        <div class="cell small-2" :class="row.Description" ></div>
                        <div class="cell auto qsmallfontplus1 qbordertext " v-html="langConv(row.Friendly)"></div>                   
                    </div>
                    
                </router-link>
              
            </div>
        </SsrCarousel>
      
    </div>
    
    <!-- horizontal menu for most popular competitions -->
    <div  v-if="ttype==2" style="display:block; width:100%">  
         <SsrCarousel :slides-per-page='10'
              :responsive="[
                { maxWidth: 1850, slidesPerPage: 9 },
                { maxWidth: 1100, slidesPerPage: 9 },
                { maxWidth:  850  , slidesPerPage: 8 },
                { maxWidth:  750, slidesPerPage: 7 },
                { maxWidth:  650  , slidesPerPage: 6 },
                { maxWidth:  550, slidesPerPage: 5 },
                { maxWidth:  450  , slidesPerPage: 4 },

            ]" 
            :show-arrows="true"
            :loop="true">

            <div class="slide" v-for="(row,i) in $store.state.popcomps" :key="i"  >
         
        
                    <!-- <a  @click="clickGo(row.CoID, String(row.Comp || '').replace(/ /g, '_'))">

                            <div  style="height:68px; width:90px;text-overflow:hidden;background-color: #E4E4E4; border-radius: 10px; padding:2px">
                                <div style="margin:2px;padding-bottom: 3px;"><img class="qflagsmall"  onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'" :src="'/assets/images/flags/svg/' + row.Co + '.svg'" :alt="row.Co"/></div> 
                                <div class="qmedsupersmallfont qborderlink text-center" style="line-height:15px;display: -webkit-box; -webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{row.Comp}}</div>
                            </div>
                    </a>         -->
               
                <router-link :to="{name:'events', params: {sport: row.Description,eventparams: String(row.Comp || '').replace(/ /g, '-') }}">
                
                            <div  style="height:68px; width:90px;text-overflow:hidden;background-color: #ffffff; border-radius: 10px; border: 1px solid #E3E5EB;
padding:2px;">
                                <div style="margin:2px;padding-bottom: 3px;"><img class="qflagsmall"  onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'" :src="'/assets/images/flags/svg/' + row.Co + '.svg'" :alt="row.Co"/></div> 
                                <div class="qmedsupersmallfont qborderlink text-center" style="line-height:15px;display: -webkit-box; -webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{row.Comp}}</div>
                            </div>
                    
                </router-link>
              
             
                </div>

            </SsrCarousel>
     <!--   <div class="cell auto" style="margin-left:25px" > -->
        <!-- <SsrCarousel  v-if="$store.state.popcomps !== undefined">
            <SsrSlide  v-for="(row,i) in $store.state.popcomps" :key="i"  >
               
       
                    <a  @click="clickGo(row.CoID, String(row2.Comp || '').replace(/ /g, '_'))">

                            <div  style="height:68px; width:90px;text-overflow:hidden;background-color: #E4E4E4; border-radius: 10px; padding:2px">
                                <div style="margin:2px;padding-bottom: 3px;"><img class="qflagsmall"  onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'" :src="'/assets/images/flags/svg/' + row.Co + '.svg'" :alt="row.Co"/></div> 
                                <div class="qmedsupersmallfont qborderlink text-center" style="line-height:15px;display: -webkit-box; -webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{row.Comp}}</div>
                            </div>
                    </a>        
              
             
            </SsrSlide>
        </SsrCarousel> -->
        <!-- </div>
        <div class="cell shrink" style="margin-right:25px"></div> -->

    </div>
     
</div>
    

</template>


<script>


    export default {

        name: "menuitems",
        components: {
    
        },
        data: function () {
            return {
                clsname: this.cn,
                ttype: this.templatetype
            }
        },
        props: {
            cn: String,
            templatetype: { type: Number, Default: 0 }
        },
        mounted() {
             this.$nextTick(()=>{ this.$refs.slick && this.$refs.slick.reSlick && this.$refs.slick.reSlick(); });
            window.addEventListener('resize', ()=>{ this.$refs.slick?.reSlick && this.$refs.slick.reSlick();  });   
        },
        methods: {
            
            clickGo: function(compdesc) {
                    
             
                    const selectedcomps = [];

                    let line = compdesc
                    selectedcomps.push(line)

                    this.$store.commit('setEventParams', selectedcomps)

                    // Navigate programmatically
                    const seoPath = selectedcomps.map(str => str.split('-')[0]).join('/')
                    this.$router.push({ name: 'events', params: { eventparams: seoPath } })

            },
        }
    }
</script>

<style scoped>



    .ci {
        display: block;
        margin: 0 auto;
    }

/* 
     #circularimage {
        background: #efefef;
        width: 30px;
        height: 32px;
        border-radius: 50%;
        display: flex; 
        justify-content: center;
        align-items: center;
        text-align: center; 
    
    }  */

    .speccol {
        display:table-cell;
        vertical-align:middle;
        padding-left:20px;
    }

   /* :not([aria-disabled]) > .ssr-carousel-left-icon, :not([aria-disabled]) > .ssr-carousel-right-icon  {
        opacity: 0.1 !important;
    }

    :not([aria-disabled]) > .ssr-carousel-left-icon, :not([aria-disabled]) > .ssr-carousel-right-icon :hover {
        opacity: 1.0;
    }
        */

:deep(.ssr-carousel-left-icon),
:deep(.ssr-carousel-right-icon) {
  width: 28px !important;
  height: 28px !important;
  opacity: 0.1 !important;
 
}

:deep(.ssr-carousel .ssr-carousel-left-icon:hover) ,
:deep(.ssr-carousel .ssr-carousel-right-icon:hover)  {

  opacity: 0.9 !important;
}

</style>
